import { render, staticRenderFns } from "./PoleStarArticle.vue?vue&type=template&id=abd2d67e&"
import script from "./PoleStarArticle.vue?vue&type=script&lang=js&"
export * from "./PoleStarArticle.vue?vue&type=script&lang=js&"
import style0 from "./PoleStarArticle.vue?vue&type=style&index=0&id=abd2d67e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports